// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const assignmentSchema = z.object({
  "application_id": z.string().uuid(),
  "name": z.string(),
  "protocol": z.enum(["oidc", "saml"]),
  "status": z.enum(["active", "disabled"]),
  "minimum_assurance": z.enum(["authenticated", "approved_federation", "phishing_resistant"]).nullable()
});

export const assignmentsPageSchema = z.object({
  "version": z.number().int().min(0),
  "items": z.array(assignmentSchema),
  "next_cursor": z.string().uuid().optional()
});

export const assignmentVersionSchema = z.object({
  "version": z.number().int().min(0)
});
